import React from 'react';
import './NavBar.scss';
import { connect } from 'react-redux';
import { setScreen, setConsent, setPurposeConsent, setPurposeLegitimateInterest, setObjectConsent, setAllConsentSwitch, setAllObjectConsentSwitch } from '../../../../redux/actions';

function allPurposes(tcData){
    let purps=0, curPurps=0;
    for(var i in tcData.purposeConsent){
        if(tcData.purposeConsent[i]){
            curPurps++;
        }
        purps++;
    }    
    return purps === curPurps;
}
function allInterests(tcData){
    let purps=0, curPurps=0, skip=1;
    for(var i in tcData.purposeLegitimateInterest){
        if(tcData.purposeLegitimateInterest[i]){
            curPurps++;
        }
        purps++;
    }
    //debugger;
    return purps - skip === curPurps;
}


const NavBar = props => {
    const changeConsent = async () => {
        let newVendorConsent = {...props.configuration.vendorConsent};
        let newPurposeConsent = {...props.configuration.purposeConsent};

        //debugger;
        let consentSwitchValue = props.consentSwitchValue;
        if(allPurposes(props.configuration)){
            consentSwitchValue = true;
        }
    
    
        const consentSwitch = props.setAllConsentSwitch(!consentSwitchValue);
        
        if(props.configuration.vendorList && props.currentFilter) {
            props.configuration.vendorList.vendors.map(vendor => {
                // if (vendor[props.currentFilter.filterName].find(filterId => filterId === props.currentFilter.value.id)) {
                    if (props.configuration.static && props.configuration.static.vendorConsent && (props.configuration.static.vendorConsent[vendor.id] === true || props.configuration.static.vendorConsent[vendor.id] === false)) {
                        newVendorConsent[vendor.id] = props.configuration.static.vendorConsent[vendor.id];
                    } else {
                        newVendorConsent[vendor.id] = consentSwitch.payload;
                    }                    
                // }

                return null;
            });
            props.setConsent(newVendorConsent);

            props.configuration.vendorList.purposes.map(purpose => {
                // if (vendor[props.currentFilter.filterName].find(filterId => filterId === props.currentFilter.value.id)) {
                    if (props.configuration.static && props.configuration.static.purposeConsent && (props.configuration.static.purposeConsent[purpose.id] === true || props.configuration.static.purposeConsent[purpose.id] === false)) {
                        newPurposeConsent[purpose.id] = props.configuration.static.purposeConsent[purpose.id];
                    } else {
                        newPurposeConsent[purpose.id] = consentSwitch.payload;
                    }
                // }

                return null;
            });
            props.setPurposeConsent(newPurposeConsent);
        }
    }

    const changeObjectConsent = () => {
        let newObjectConsent = {...props.configuration.objectConsent};
        let newPurposeLegitimateInterest = {...props.configuration.purposeLegitimateInterest};
        
        let objectConsentSwitchValue = props.objectConsentSwitchValue;
        if(allInterests(props.configuration)){
            objectConsentSwitchValue = true;
        }
        const objectConsentSwitch = props.setAllObjectConsentSwitch(!objectConsentSwitchValue);

        if(props.configuration.vendorList && props.currentFilter) {
            props.configuration.vendorList.vendors.map(vendor => {
                // if (vendor.legIntPurposes.length > 0 && vendor[props.currentFilter.filterName].find(filterId => filterId === props.currentFilter.value.id)) {

                if (vendor.legIntPurposes.length > 0) {
                    if (props.configuration.static && props.configuration.static.objectConsent && (props.configuration.static.objectConsent[vendor.id] === true || props.configuration.static.objectConsent[vendor.id] === false)) {
                        newObjectConsent[vendor.id] = props.configuration.static.objectConsent[vendor.id];
                    } else {
                        newObjectConsent[vendor.id] = objectConsentSwitch.payload;
                    }
                }

                return null;
            });
            props.setObjectConsent(newObjectConsent);

            props.configuration.vendorList.purposes.map(purpose => {
                if (props.configuration.static && props.configuration.static.purposeLegitimateInterest && (props.configuration.static.purposeLegitimateInterest[purpose.id] === true || props.configuration.static.purposeLegitimateInterest[purpose.id] === false)) {
                    newPurposeLegitimateInterest[purpose.id] = props.configuration.static.purposeLegitimateInterest[purpose.id];
                } else {
                    newPurposeLegitimateInterest[purpose.id] = objectConsentSwitch.payload;
                } 

                return null;
            });
            props.setPurposeLegitimateInterest(newPurposeLegitimateInterest);
        }
    }

    //debugger;
    let consentSwitchValue = props.consentSwitchValue;
    if(allPurposes(props.configuration)){
        consentSwitchValue = true;
    }
    
    let objectConsentSwitchValue = props.objectConsentSwitchValue;
    if(allInterests(props.configuration)){
        objectConsentSwitchValue = true;
    }

    return (
        <div id="navbar">
           <div id="backbutton" onClick={() => props.setScreen(1)}> <p>« {props.currentLanguage.text.backButton}</p></div>
           <div id="selectbuttons">
                <span>{props.currentLanguage.text.selectAll || '(de)select all:'} </span>
                <span className="label">{props.currentLanguage.text.labels.consent || 'Consent'}</span>
                <label className="switch">
                    <input type="checkbox" checked={consentSwitchValue} onChange={() => { changeConsent()}} />
                    <i className="slider consent" />
                </label>
                
                <span className="label">{props.currentLanguage.text.labels.legitimateInterest || 'Legitimate Interest'}</span>
                <label className="switch">
                    <input type="checkbox" checked={objectConsentSwitchValue} onChange={() => { changeObjectConsent()}} />
                    <i className="slider orange object" />
                </label>
            </div>
        </div>
    )
};

const mapStateToProps = state => {
    return {...state};
}

export default connect(mapStateToProps, {setScreen, setConsent, setPurposeConsent, setPurposeLegitimateInterest, setObjectConsent, setAllConsentSwitch, setAllObjectConsentSwitch})(NavBar);
